var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconDollar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M32.07 35.677H4.302a3.59 3.59 0 0 1-3.579-3.58V4.33A3.59 3.59 0 0 1 4.303.75H32.07a3.59 3.59 0 0 1 3.58 3.58v27.768a3.589 3.589 0 0 1-3.58 3.579z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "text-before-edge",
    transform: "translate(11 3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#666",
    fontFamily: "'Avenir Next Medium','AvenirNext-Medium'",
    fontSize: 24.18,
    fontWeight: 700
  }, "$")))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDollar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_dollar.b68a132b.svg";
export { ForwardRef as ReactComponent };